import { TUI_KINDS, type TuiAdapter, type TuiKind } from "./types.js";
import { ClaudeTuiAdapter } from "./claude.js";
import { OpenCodeTuiAdapter } from "./opencode.js";

export * from "./types.js";
export { ClaudeTuiAdapter } from "./claude.js";
export { OpenCodeTuiAdapter } from "./opencode.js";

/**
 * Which TUI a pod runs, from the bootstrap bundle's CONVEYOR_TUI.
 *
 * Unknown values throw (fail loudly): a typo'd config must not silently fall
 * back to Claude while the bundle seeded some other TUI's credentials — the
 * pod would spawn `claude` and park at a sign-in prompt with no clue why.
 *
 * Shared by the adhoc-session path and the task/card path (`QueryBridge`), so
 * both honor the same value with the same contract.
 */
export function resolveTuiKindFromEnv(env: NodeJS.ProcessEnv): TuiKind {
  const raw = env.CONVEYOR_TUI ?? "claude-code";
  if ((TUI_KINDS as readonly string[]).includes(raw)) return raw as TuiKind;
  throw new Error(`Unknown TUI "${raw}" in CONVEYOR_TUI (expected: ${TUI_KINDS.join(", ")})`);
}

/** Adapter factory. */
export function resolveTuiAdapter(kind: TuiKind = "claude-code"): TuiAdapter {
  switch (kind) {
    case "claude-code":
      return new ClaudeTuiAdapter();
    case "opencode":
      return new OpenCodeTuiAdapter();
    default:
      throw new Error(`Unknown TUI kind: ${kind as string}`);
  }
}
